export default "__VITE_ASSET__Cv9$FmGm__"